module.exports = Object.freeze({
  EDITOR_STATE: 'editor_state',
  USER_CONFIG: 'settings',
  USER_PROGRESS: 'progress',
  USER_LICENSES: 'licenses',
  LESSON_CONTENT: 'lessons',
})